import BrazilianCompanyContext from "components/company/v3/context/BrazilianCompanyContext";
import { useContext } from "react";

export default function useBrazilianIssuer() {
  const brazilianIssuer = useContext(BrazilianCompanyContext);

  if (!brazilianIssuer) {
    throw new Error("No root issuer found. Make sure you're using this hook inside a issuer's context");
  }
  return brazilianIssuer;
}
